import axios from 'axios';
import { GeneralIds, ModelTypes, Models } from 'types/types';
import { normalize, denormalize, getURLByModelType } from 'api/models/index';
import { ROOT_URL, API_VERSION } from 'constants/index';

interface Params {
  type: ModelTypes;
  body: Models;
  ids?: GeneralIds;
}

export async function mutation<T>({
  type,
  body,
  ids,
}: Params): Promise<{ data: T | null }> {
  const { data } = await axios({
    method: body.id ? 'PATCH' : 'POST',
    url: `${ROOT_URL}/${API_VERSION}/${getURLByModelType(type, ids)}`,
    data: denormalize(body),
  });

  return data ? { data: normalize(data) } : { data: null };
}
